import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import Transition from '@ember/routing/-private/transition';
import TemplateController from './controller';
import TemplateModel from 'cio/models/template';
import { createComposerEditableEntity } from 'cio/utils/composer/composer-editable-entity';
import DS from 'ember-data';
import ConfirmChangesService from 'cio/services/confirm-changes';
import SubscriptionCenterService from 'cio/services/subscription-center';
import NewsletterModel from 'cio/models/newsletter';
import { ComposerSection } from 'cio/components/action-composer';

export default class TemplateRoute extends Route {
  @service store!: DS.Store;
  @service confirmChanges!: ConfirmChangesService;
  @service subscriptionCenter!: SubscriptionCenterService;

  model(params: { template_id: string }) {
    return this.store.findRecord('template', params.template_id);
  }

  afterModel() {
    return this.subscriptionCenter.initializeTask.perform();
  }

  setupController(controller: TemplateController, model: TemplateModel, transition: Transition) {
    super.setupController(controller, model, transition);

    let newsletter = this.modelFor('composer.newsletter') as NewsletterModel;

    let owner = getOwner(this);
    let editableEntity = createComposerEditableEntity(owner, { newsletter, template: model });

    controller.setProperties({
      selectedEditor: null,
      editableEntity,
    });

    controller.setEditor();
    this.confirmChanges.register(controller, this);
  }

  resetController(controller: TemplateController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    controller.set('currentTab', ComposerSection.Editor);
  }
}
